import type { FC } from 'react'
import React from 'react'
import { EIconSize, Icon } from '@frontend/pole-ui/lib/components/Icon'
import { EmptyStateIcon } from '@frontend/pole-ui/lib/components/Icon/svg/EmptyStateIcon'
import { messages } from './messages'
import './styles.scss'

export const JournalSearchListEmpty: FC = () => {
  return (
    <div className="journalSearchListEmpty">
      <Icon component={<EmptyStateIcon />} size={EIconSize.L} />

      <h5 className="journalSearchListEmpty__title">{messages.title}</h5>
      <p>{messages.subTitle}</p>
    </div>
  )
}
